import {
    HEADER_DATA_START,
    HEADER_DATA_SUCCESS,
    HEADER_DATA_ERROR,
  } from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
};
  
export default function headerDataReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case HEADER_DATA_START:
        return {
          ...state,
          loading: true,
        };
      case HEADER_DATA_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case HEADER_DATA_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  